module.exports = __webpack_public_path__ + "assets/01c041d32fb5cfcdc726525dfc275bc5.mp3";